// Private

// loading all svgs and making them as components using svg-loader
const requireComponents = require.context('../assets/icons/', false, /.svg$/);
const icons = requireComponents.keys().reduce((icons, fileName) => {
	const iconName = fileName.replace(/^\.\/icon-(.+)\.svg$/, '$1');
	icons[iconName] = {
		importer: () => {
			const componentConfig = requireComponents(fileName);
			return componentConfig.default || componentConfig;
		},
	};
	return icons;
}, {});

// Public

const hasIcon = (iconName) => icons.hasOwnProperty(iconName);

const getIcon = (iconName) => {
	if (!hasIcon(iconName)) throw new Error(`Icon ${iconName} does not exist`);
	// return (icons[iconName].cache ??= icons[iconName].importer());
	if (!icons[iconName].cache) {
		icons[iconName].cache = icons[iconName].importer();
	}
	return icons[iconName].cache;
};

const getExternalIconUrl = (iconName) => `${process.env.VUE_APP_PLY_BACKEND_ASSETS_URL}icons/${iconName}.svg`;

const IconService = { hasIcon, getIcon, getExternalIconUrl };

export default IconService;
